import api from './../../api/api'

export default {
  
  users: async (page, take, sortBy, sortOrder, search,filters) => {
    return api.get(`api/users?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createRelatedData: async () => {
    return api.get('api/users/create')
  },

  create: async user => {
    return api.post('api/users', user)
  },

  updateFcmToken: async token => {
    return api.post('api/update-fcm-token',{fcm_token:token})
  },

  get: async id => {
    return api.get('api/users/' + id)
  },

  update: async (id, user) => {
    return api.put('api/users/' + id, user)
  },

  delete: async id => {
    return api.delete('api/users/' + id)
  },

  
  guestSignUp: async data => {
    await api.get('sanctum/csrf-cookie')
    return api.post('api/guest-sign-up', data)
  },
}
